import { apiClient } from './api'

// Shape of a single recipient row in the bulk-checkout form.
export interface BulkRecipient {
  name?: string
  email: string
}

// Request body sent to POST /checkout/bulk.
export interface CreateBulkOrderRequest {
  courseId: string
  batchId?: string
  paymentChannel: string
  customerName: string
  customerPhone?: string
  recipients: BulkRecipient[]
}

// Response envelope returned on success.
export interface CreateBulkOrderResponse {
  paymentId: string
  externalId: string
  paymentUrl: string
  totalAmount: number
  ticketCount: number
  invitations: Array<{ id: string; invitedEmail: string; invitedName?: string; status: string }>
}

interface ApiEnvelope<T> {
  success: boolean
  data: T
  error?: { code: string; message: string }
}

export const checkoutService = {
  /** createBulkOrder — POST /api/v1/checkout/bulk. Returns the Pivot payment URL. */
  createBulkOrder: async (req: CreateBulkOrderRequest): Promise<CreateBulkOrderResponse> => {
    const resp = await apiClient.post<ApiEnvelope<Record<string, unknown>>>('/checkout/bulk', {
      course_id: req.courseId,
      batch_id: req.batchId,
      payment_channel: req.paymentChannel,
      customer_name: req.customerName,
      customer_phone: req.customerPhone,
      recipients: req.recipients.map((r) => ({ name: r.name, email: r.email })),
    })
    if (!resp.data?.success) {
      throw new Error(resp.data?.error?.message || 'Failed to create bulk order')
    }
    const raw = resp.data.data
    return {
      paymentId: raw.payment_id as string,
      externalId: raw.external_id as string,
      paymentUrl: (raw.payment_url as string) || '',
      totalAmount: raw.total_amount as number,
      ticketCount: raw.ticket_count as number,
      invitations: ((raw.invitations as Array<Record<string, unknown>>) || []).map((i) => ({
        id: i.id as string,
        invitedEmail: i.invited_email as string,
        invitedName: i.invited_name as string | undefined,
        status: i.status as string,
      })),
    }
  },
}

export default checkoutService
